var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "desp"
  }, [_c('div', {
    staticClass: "desp-header"
  }, [_vm._v("Linked Refund Orders")]), _vm._l(_vm.detail.orderRefundList, function (item) {
    var _item$refundingTeller, _item$refundingTeller2;

    return _c('div', {
      key: "orderRefundList-".concat(item.id),
      staticClass: "desp-items-group"
    }, [_c('div', {
      staticClass: "desp-items-group-title"
    }, [_vm._v("Refund Order")]), _c('div', {
      staticClass: "desp-items-wrapper"
    }, [_c('el-row', {
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Refund Teller")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(_vm._s(((_item$refundingTeller = item.refundingTeller) === null || _item$refundingTeller === void 0 ? void 0 : _item$refundingTeller.nickname) || ((_item$refundingTeller2 = item.refundingTeller) === null || _item$refundingTeller2 === void 0 ? void 0 : _item$refundingTeller2.username) || ""))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Transaction No.")]), _c('div', {
      staticClass: "blue crp desp-item-content",
      on: {
        "click": function click($event) {
          return _vm.toLinkRefundOrderDetail(item.id);
        }
      }
    }, [_vm._v(_vm._s(item.businessNo))])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Refund No.")]), _c('div', {
      staticClass: "blue crp desp-item-content",
      on: {
        "click": function click($event) {
          return _vm.invoiceLink(item.refundNo);
        }
      }
    }, [_vm._v(" " + _vm._s(item.refundNo || "") + " ")])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Refund Status")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(" " + _vm._s(_vm.refundStatusFormat(item.status)) + " ")])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Refund Create Time")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(" " + _vm._s(item.applyTime || "") + " ")])])]), _c('el-col', {
      attrs: {
        "span": 8
      }
    }, [_c('div', {
      staticClass: "desp-item"
    }, [_c('div', {
      staticClass: "desp-item-label"
    }, [_vm._v("Apply Reason")]), _c('div', {
      staticClass: "desp-item-content"
    }, [_vm._v(" " + _vm._s(item.applyReason || "") + " ")])])])], 1)], 1)]);
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }